import { ModalLayer } from '@app/components/Molecules/LayersControl'
import { RootState } from '@app/redux/store'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

type UseMapLayersReturn = {
  layers: ModalLayer[]
  elementLayers: string[]
  hazardLayers: string[]
  informationLayers: string[]
  liveLayers: string[]
  isMapEmpty: boolean
}

export const useMapLayers = (): UseMapLayersReturn => {
  const { layers: storeLayers } = useSelector((state: RootState) => state.riskMap)

  const layers = useMemo(
    () =>
      storeLayers.reduce<ModalLayer[]>((acc, layer) => {
        const layerType = layer.layerType
        const layerGroup = acc.find((group) => group.id === layerType)

        if (layerGroup) {
          layerGroup.layers.push(layer)
        } else {
          acc.push({
            id: layerType,
            layers: [layer],
          })
        }

        return acc
      }, []),
    [storeLayers],
  )

  const elementLayers = useMemo(
    () => storeLayers.filter((layer) => layer.layerType === 'asset').map((layer) => layer.type),
    [storeLayers],
  )
  const hazardLayers = useMemo(
    () =>
      storeLayers.filter((layer) => layer.layerType === 'hazard').map((layer) => layer.assetTag),
    [storeLayers],
  )
  const informationLayers = useMemo(
    () => storeLayers.filter((layer) => layer.layerType === 'information').map((layer) => layer.id),
    [storeLayers],
  )
  const liveLayers = useMemo(
    () => storeLayers.filter((layer) => layer.layerType === 'live').map((layer) => layer.id),
    [storeLayers],
  )
  const isMapEmpty = useMemo(
    () => elementLayers.length === 0 && hazardLayers.length === 0 && informationLayers.length === 0,
    [elementLayers, hazardLayers, informationLayers],
  )
  return { layers, elementLayers, hazardLayers, informationLayers, liveLayers, isMapEmpty }
}
